export var IDisclaimer;
(function (IDisclaimer) {
    let Icon;
    (function (Icon) {
        Icon["ICON_UNKNOWN"] = "ICON_UNKNOWN";
        Icon["INTERNATIONAL"] = "INTERNATIONAL";
        Icon["CAUTION"] = "CAUTION";
        Icon["DOLLAR_SIGN"] = "DOLLAR_SIGN";
        Icon["PERCENT_SIGN"] = "PERCENT_SIGN";
        Icon["SHIPMENT_DELIVERED"] = "SHIPMENT_DELIVERED";
        Icon["STACK_BILL"] = "STACK_BILL";
        Icon["DIAMOND"] = "DIAMOND";
        Icon["CALENDAR"] = "CALENDAR";
        Icon["DOLLAR_SIGN_WITH_CIRCLE_ARROW"] = "DOLLAR_SIGN_WITH_CIRCLE_ARROW";
    })(Icon = IDisclaimer.Icon || (IDisclaimer.Icon = {}));
    let Type;
    (function (Type) {
        Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
        Type["INSTRUMENT_BLOCKER"] = "INSTRUMENT_BLOCKER";
        Type["PREPAID_CARD_BLOCKER"] = "PREPAID_CARD_BLOCKER";
        Type["PREPAID_CARD_NET_BLOCKER"] = "PREPAID_CARD_NET_BLOCKER";
        Type["REGION_RESTRICTION"] = "REGION_RESTRICTION";
        Type["FACE_MASK"] = "FACE_MASK";
        Type["INSTRUMENT_MUST_BE_UPDATED"] = "INSTRUMENT_MUST_BE_UPDATED";
        Type["INSIDER"] = "INSIDER";
        Type["ECO_FRIENDLY_OFFSETS"] = "ECO_FRIENDLY_OFFSETS";
        Type["RESELLER_CERTIFICATE_REQUIRED"] = "RESELLER_CERTIFICATE_REQUIRED";
        Type["FAIRE_PAY_UPSELL"] = "FAIRE_PAY_UPSELL";
        Type["FAIRE_PAY_SAVING"] = "FAIRE_PAY_SAVING";
        Type["UNPAID_EXCLUSIVITY_AGREEMENT"] = "UNPAID_EXCLUSIVITY_AGREEMENT";
    })(Type = IDisclaimer.Type || (IDisclaimer.Type = {}));
    /**
     * Return an instance of IDisclaimer with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IDisclaimer.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IDisclaimer || (IDisclaimer = {}));
